// The two entry types the shared Surplus/write-off modal offers.
export const SURPLUS_WRITEOFF_TYPES = Object.freeze({
  surplus: 'SURPLUS',
  writeOff: 'WRITE_OFF',
});
